module.exports = __webpack_public_path__ + "static/media/image-1.bf7385df.png";